import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormGroup,
  FormField,
  Dropdown
} from 'semantic-ui-react'

const CardSummaryTrainingKPIUX = (props: any) => {
    return(
      <div
        style={{padding: "10px"}}>
        <Form
          className="small"
          id="CardEmployeeSummaryWorkHourUX-Form-1">
          <FormGroup
            id="CardEmployeeSummaryWorkHourUX-FormGroup-2">
            <FormField
              id="CardEmployeeSummaryWorkHourUX-FormField-6">
              <label
                id="CardEmployeeSummaryWorkHourUX-label-7">
                Month
              </label>
              <Dropdown
                id="CardEmployeeSummaryWorkHourUX-Dropdown-8"
                name="month"
                onChange={props.onChangeFilter}
                options={props.monthOptions}
                search={true}
                selection={true}
                value={props.filter?.month?? ""}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardEmployeeSummaryWorkHourUX-FormField-9">
              <label
                id="CardEmployeeSummaryWorkHourUX-label-10">
                Year
              </label>
              <Dropdown
                id="CardEmployeeSummaryWorkHourUX-Dropdown-11"
                name="year"
                onChange={props.onChangeFilter}
                options={props.yearOptions}
                search={true}
                selection={true}
                value={props.filter?.year?? ""}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardSummaryTrainingKPIUX-FormField-20">
              <label
                id="CardSummaryTrainingKPIUX-label-21">
                Division
              </label>
              <Dropdown
                id="CardSummaryTrainingKPIUX-Dropdown-22"
                name="division_id"
                onChange={props.onChangeFilter}
                options={props.divisionOptions}
                search={true}
                selection={true}
                value={props.filter?.division_id?? ""}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardEmployeeSummaryWorkHourUX-FormField-12">
              <label
                id="CardEmployeeSummaryWorkHourUX-label-14">
                {"\u00A0"}
              </label>
              <div
                id="CardEmployeeSummaryWorkHourUX-div-13">
                {props.buttonSearch}
              </div>
            </FormField>
            <FormField
              id="CardSummaryTrainingKPIUX-FormField-23">
              <label
                id="CardSummaryTrainingKPIUX-label-24">
                {"\u00A0"}
              </label>
              <div
                id="CardSummaryTrainingKPIUX-div-25">
                {props.buttonPrint}
              </div>
            </FormField>
          </FormGroup>
        </Form>
        <div
          id="CardEmployeeSummaryWorkHourUX-div-15">
          {props.table}
        </div>
        <div
          id="CardEmployeeSummaryWorkHourUX-div-16"
          style={{marginTop: "1rem", display: "flex", justifyContent: "flex-end", alignItems: "center"}}>

          <div
            id="CardSummaryTrainingKPIUX-div-26"
            style={{marginRight: "1rem", display: props.latestEdited?"":"none"}}>
            {`Last updated by ${props.latestEdited}`}
          </div>
          <div
            id="CardSummaryTrainingKPIUX-div-27">
            {props.buttonSave}
          </div>
        </div>
      </div>
    )
}


export default CardSummaryTrainingKPIUX

export const screenPropsDefault = {"cannotPay":false,"cashAmountText":"14","citizenID":"31020000552","oweText":123,"patientNameAndHN":"HN: xxxxx นายทดสอบ","sumAmount":{"price":100,"reimbursable":42}}

/* Date Time : Fri Jun 27 2025 10:36:37 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": "semantic-ui-react",
      "id": 1,
      "name": "Form",
      "parent": 0,
      "props": {
        "className": {
          "type": "value",
          "value": "small"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-Form-1"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 2,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-FormGroup-2"
        },
        "inline": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-FormField-6"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 7,
      "name": "label",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": "Month"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-label-7"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "Dropdown",
      "parent": 6,
      "props": {
        "clearable": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-Dropdown-8"
        },
        "name": {
          "type": "value",
          "value": "month"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "options": {
          "type": "code",
          "value": "props.monthOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.filter?.month?? \"\""
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-FormField-9"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": null,
      "id": 10,
      "name": "label",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": "Year"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-label-10"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 11,
      "name": "Dropdown",
      "parent": 9,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-Dropdown-11"
        },
        "name": {
          "type": "value",
          "value": "year"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "options": {
          "type": "code",
          "value": "props.yearOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.filter?.year?? \"\""
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 12,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-FormField-12"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": null,
      "id": 13,
      "name": "div",
      "parent": 12,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSearch"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-div-13"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 14,
      "name": "label",
      "parent": 12,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00A0\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-label-14"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.table"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-div-15"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 16,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-div-16"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"1rem\", display: \"flex\", justifyContent: \"flex-end\", alignItems: \"center\"}"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 20,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSummaryTrainingKPIUX-FormField-20"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": null,
      "id": 21,
      "name": "label",
      "parent": 20,
      "props": {
        "children": {
          "type": "value",
          "value": "Division"
        },
        "id": {
          "type": "value",
          "value": "CardSummaryTrainingKPIUX-label-21"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 22,
      "name": "Dropdown",
      "parent": 20,
      "props": {
        "fluid": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSummaryTrainingKPIUX-Dropdown-22"
        },
        "name": {
          "type": "value",
          "value": "division_id"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "options": {
          "type": "code",
          "value": "props.divisionOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.filter?.division_id?? \"\""
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 23,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSummaryTrainingKPIUX-FormField-23"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": null,
      "id": 24,
      "name": "label",
      "parent": 23,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00A0\""
        },
        "id": {
          "type": "value",
          "value": "CardSummaryTrainingKPIUX-label-24"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": null,
      "id": 25,
      "name": "div",
      "parent": 23,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonPrint"
        },
        "id": {
          "type": "value",
          "value": "CardSummaryTrainingKPIUX-div-25"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": null,
      "id": 26,
      "name": "div",
      "parent": 16,
      "props": {
        "children": {
          "type": "code",
          "value": "`Last updated by ${props.latestEdited}`"
        },
        "id": {
          "type": "value",
          "value": "CardSummaryTrainingKPIUX-div-26"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"1rem\", display: props.latestEdited?\"\":\"none\"}"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": null,
      "id": 27,
      "name": "div",
      "parent": 16,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSave"
        },
        "id": {
          "type": "value",
          "value": "CardSummaryTrainingKPIUX-div-27"
        }
      },
      "seq": 27,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardSummaryTrainingKPIUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "cannotPay": false,
    "cashAmountText": "14",
    "citizenID": "31020000552",
    "oweText": 123,
    "patientNameAndHN": "HN: xxxxx นายทดสอบ",
    "sumAmount": {
      "price": 100,
      "reimbursable": 42
    }
  },
  "width": 75
}

*********************************************************************************** */
